import moment from "moment";

export const DEADLINES_FILTERS_KEY = "relatorios.prazos";

// Defaults depend on "today", so they are built at mount (usePersistedFilters).
// The month is kept as 'YYYY-MM', never as a moment.
export const getDefaultDeadlinesFilters = () => ({
  month: moment().format("YYYY-MM"),
});

// Turns the saved month into the /deadlines/{date} params (last day of the month).
// Builds a fresh moment from the string, so nothing kept in state is mutated.
export const getDeadlinesRequest = (filters) => ({
  date: moment(filters.month, "YYYY-MM").endOf("month").format("YYYY-MM-DD"),
});

export const isDeadlinesMonthDefault = (filters, defaults) =>
  filters.month === defaults.month;

export const getDeadlinesMonthLabel = (filters) =>
  moment(filters.month, "YYYY-MM").format("MMM/YYYY");

// Badge: only what differs from the defaults.
export const countActiveDeadlinesFilters = (filters, defaults) =>
  isDeadlinesMonthDefault(filters, defaults) ? 0 : 1;
